import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <p>{t('footer.copyright')}</p>
    </footer>
  );
};

export default Footer; 